var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-image-advert flex-center"},[(!_vm.imageList.length)?_c('p',[_vm._v("未添加图片")]):_vm._e(),_vm._l((_vm.imageList),function(item,i){return _c('img',{key:i,style:({
            'width': item.width,
            'height': item.height,
            'margin-left': item.margin
        }),attrs:{"src":item.img_url}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }